import { render, staticRenderFns } from "./study.vue?vue&type=template&id=7b51bea8&scoped=true&lang=pug"
import script from "./study.vue?vue&type=script&lang=ts"
export * from "./study.vue?vue&type=script&lang=ts"
import style0 from "./study.vue?vue&type=style&index=0&id=7b51bea8&prod&lang=stylus&scoped=true"
import style1 from "./study.vue?vue&type=style&index=1&id=7b51bea8&prod&lang=stylus&scoped=true"
import style2 from "./study.vue?vue&type=style&index=2&id=7b51bea8&prod&lang=stylus&scoped=true"
import style3 from "./study.vue?vue&type=style&index=3&id=7b51bea8&prod&lang=stylus&scoped=true"
import style4 from "./study.vue?vue&type=style&index=4&id=7b51bea8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b51bea8",
  null
  
)

export default component.exports